'use client';

import { Button } from '@mantine/core';
import { Text } from '@mantine/core';
import { Link } from 'next-intl';

import css from './HeroAcademySection.module.css';
export type HeroAcademySectionProps = {
  locale: string;
  firstSlug: string;
  title: string;
  description: string;
  cta: string;
};

export const HeroAcademySection = ({
  locale,
  firstSlug,
  title,
  description,
  cta,
}: HeroAcademySectionProps) => {
  return (
    <div className={css.container}>
      <div className={css.hero}>
        <Text variant="displayLg.semibold">{title}</Text>
        <Text variant="textXl.regular">{description}</Text>

        <Button
          variant="filled"
          w={'fit-content'}
          size="md"
          component={Link}
          locale={locale}
          href={`/help-center/${firstSlug}`}
        >
          {cta}
        </Button>
      </div>
    </div>
  );
};
